<template>
    <section id="general">
        <p
            class="
                is-size-5
                has-text-centered has-text-weight-bold
                is-uppercase
                pt-2
                mb-0
                pb-2
                has-background-very-light-pink
            "
        >
            {{ $t('Sessions.general_data') }}
        </p>
        <hr class="navbar-divider has-background-grey-lighter mt-0" />

        <nav class="level is-mobile pt-3">
            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.ranking_position')"
                    :number="player.position"
                />
            </div>

            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.score_achieved')"
                    :number="player.score"
                />
            </div>

            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.question_hit_rate')"
                    :number="player.hitRate"
                />
            </div>
        </nav>

        <hr class="navbar-divider has-background-grey-lighter" />

        <table class="table is-fullwidth is-narrow mb-3">
            <tbody>
                <tr>
                    <td>{{ $t('Sessions.game_date') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.playedDate }}
                    </td>
                    <td>{{ $t('Sessions.game_time') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.gameTime }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('Sessions.game_device') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.device }}
                    </td>
                    <td>
                        {{ $t('Sessions.game_time_per_answer') }}
                    </td>
                    <td class="has-text-weight-bold">
                        {{ player.meanTime }}
                    </td>
                </tr>
            </tbody>
        </table>

        <hr class="navbar-divider has-background-grey-lighter mb-0" />
    </section>
</template>

<script>
import SessionEndResumeBubble from '@/components/SessionEndResumeBubble';

export default {
    name: 'SessionDetailPlayerGeneral',
    components: {
        SessionEndResumeBubble,
    },
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style scoped>
.table tr:not(.is-bordered-bottom) {
    border: none;
}
.content table td {
    border: none;
}
</style>
